import React from 'react'
import FAQItem from './FAQItem'

const FAQ = ({ faqs }) => {
  return faqs.map((faq) => <FAQItem key={faq.uniqueId} {...faq} />)
}

export default FAQ
